import axios from "axios";
import toast from "react-hot-toast";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const getToken = () => localStorage.getItem("token");

export const FETCH_OFFICES_REQUEST = "FETCH_OFFICES_REQUEST";
export const FETCH_OFFICES_SUCCESS = "FETCH_OFFICES_SUCCESS";
export const FETCH_OFFICES_FAILURE = "FETCH_OFFICES_FAILURE";

export const CREATE_OFFICE_REQUEST = "CREATE_OFFICE_REQUEST";
export const CREATE_OFFICE_SUCCESS = "CREATE_OFFICE_SUCCESS";
export const CREATE_OFFICE_FAILURE = "CREATE_OFFICE_FAILURE";

export const UPDATE_OFFICE_REQUEST = "UPDATE_OFFICE_REQUEST";
export const UPDATE_OFFICE_SUCCESS = "UPDATE_OFFICE_SUCCESS";
export const UPDATE_OFFICE_FAILURE = "UPDATE_OFFICE_FAILURE";

export const DELETE_OFFICE_REQUEST = "DELETE_OFFICE_REQUEST";
export const DELETE_OFFICE_SUCCESS = "DELETE_OFFICE_SUCCESS";
export const DELETE_OFFICE_FAILURE = "DELETE_OFFICE_FAILURE";

// Fetch All Offices
export const fetchOffices = () => async (dispatch) => {
  dispatch({ type: FETCH_OFFICES_REQUEST });
  try {
    const response = await axios.get(`${BASE_URL}/v1/api/admin/getOffices`, {
      headers: { Authorization: getToken() },
    });
    dispatch({
      type: FETCH_OFFICES_SUCCESS,
      payload: response.data?.data || [],
    });
  } catch (error) {
    const errorMsg = error.response?.data?.message || error.message || "Failed to fetch offices";
    dispatch({ type: FETCH_OFFICES_FAILURE, payload: String(errorMsg) });
    toast.error(String(errorMsg));
  }
};

// Create Office
export const createOffice = (officeData) => async (dispatch) => {
  dispatch({ type: CREATE_OFFICE_REQUEST });
  try {
    const response = await axios.post(`${BASE_URL}/v1/api/admin/createOffice`, officeData, {
      headers: { Authorization: getToken() },
    });
    dispatch({ type: CREATE_OFFICE_SUCCESS, payload: response.data?.data });
    toast.success("Office created successfully");
    return true;
  } catch (error) {
    const errorMsg = error.response?.data?.message || error.message;
    dispatch({ type: CREATE_OFFICE_FAILURE, payload: errorMsg });
    toast.error(errorMsg);
    return false;
  }
};

// Update Office
export const updateOffice = (id, officeData) => async (dispatch) => {
  dispatch({ type: UPDATE_OFFICE_REQUEST });
  try {
    const response = await axios.put(`${BASE_URL}/v1/api/admin/updateOffice/${id}`, officeData, {
      headers: { Authorization: getToken() },
    });
    dispatch({ type: UPDATE_OFFICE_SUCCESS, payload: response.data?.data });
    toast.success("Office updated successfully");
  } catch (error) {
    dispatch({ type: UPDATE_OFFICE_FAILURE, payload: error.message });
    toast.error("Update failed");
  }
};

// Delete Office
export const deleteOffice = (id) => async (dispatch) => {
  dispatch({ type: DELETE_OFFICE_REQUEST });
  try {
    await axios.delete(`${BASE_URL}/v1/api/admin/deleteOffice/${id}`, {
      headers: { Authorization: getToken() },
    });
    dispatch({ type: DELETE_OFFICE_SUCCESS, payload: id });
    toast.success("Office deleted successfully");
  } catch (error) {
    const errorMsg = error.response?.data?.message || error.message || "Delete failed";
    dispatch({ type: DELETE_OFFICE_FAILURE, payload: String(errorMsg) });
    toast.error(String(errorMsg));
  }
};